import React, {Component} from 'react'
import {Map, TileLayer, Marker, Popup} from 'react-leaflet'


// Otherwise CSS3 markers do not show up:
// https://stackoverflow.com/a/56186994/1497211
import Leaflet from 'leaflet'
Leaflet.Icon.Default.imagePath =
  '//cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/'

class MyMap extends Component {
    state = {
        lat: 51.505,
        lng: -0.09,
        zoom: 10,
        zoomOffset: 1
    }

    render() {
        const position = [this.state.lat, this.state.lng]
        return (
            <div style={{
                height: "100vh",
                width: "100%"
            }}>
                <Map style={{
                height: "100%",
                width: "100%"}} center={position} zoom={this.state.zoom} zoomOffset={this.zoomOffset}>
                    <TileLayer
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={position}>
                        <Popup>
                            A pretty CSS3 popup.
                            <br/>
                            Easily customizable.
                        </Popup>
                    </Marker>
                </Map>
            </div>
        )
    }
}

export default MyMap;
